import 'css/desktop/blog-display.scss';

import 'js/desktop/common/common.jquery.js';
